/* eslint-disable no-undef */
// Load Google Charts only once at the beginning
google.charts.load("current", { packages: ["corechart"] });

// Set up a single callback function that will run all our charts
google.charts.setOnLoadCallback(() => {
  try {
    // Call all chart drawing functions here
    if (apiData && apiData.flourishDemographic && apiData.flourishDemographic.byWorkForce) {
      drawIndividualWorkforceCharts();
    }
    
    // Check if scam method data exists
    if (apiData && apiData.flourishScamSection && apiData.flourishScamSection.byMethod) {
      drawScamMethodBarCharts();
      
      // Draw scam charts by method
      if (apiData.flourishScamSection.byMethod.data && apiData.flourishScamSection.byMethod.data.data) {
        drawScamChartGroup(
          apiData.flourishScamSection.byMethod.data.data,
          "Method",
          ["Wireless/Mobile", "Wired", "VOIP"],
          ["#2e3192", "#dc3912", "#ff9900"]
        );
      }
    }

    // Check if scam type data exists
    if (apiData && apiData.flourishScamSection && apiData.flourishScamSection.byType && 
        apiData.flourishScamSection.byType.data && apiData.flourishScamSection.byType.data.data) {
      drawScamChartGroup(
        apiData.flourishScamSection.byType.data.data,
        "Type",
        ["Pre-recorded Voice", "Live Voice", "Abandoned Calls", "Text Message"],
        ["#2e3192", "#dc3912", "#ff9900", "#109618"]
      );
    }
    
    // Check if scam issue data exists
    if (apiData && apiData.flourishScamSection && apiData.flourishScamSection.byIssue && 
        apiData.flourishScamSection.byIssue.data && apiData.flourishScamSection.byIssue.data.data) {
      // Draw issue charts with updated labels
      drawScamLineChartGroup(
        apiData.flourishScamSection.byIssue.data.data,
        "Issue",
        ["Unwanted Calls", "Telemarketing", "Robocalls"],
        ["#2e3192", "#dc3912", "#ff9900"]
      );
    }
  } catch (error) {
    console.warn("An error occurred while rendering charts.");
    if (window.location.hostname === "localhost") {
      console.debug("Chart error:", error);
    }
  }
});

function getChartOptions(title, color) {
  return {
    title: title,
    fontSize: 12,
    fontWeight: "bold",
    legend: { position: "bottom" },
    curveType: "function",
    lineWidth: 4,
    pointSize: 6,
    animation: {
      duration: 1000,
      easing: "out",
      startup: true,
    },
    chartArea: {
      left: 40,
      width: "80%",
      height: "70%",
    },
    hAxis: {
      title: "Year",
      slantedText: true,
    },
    vAxis: {
      title: "%",
      gridlines: {
        count: 6,
      },
      slantedText: true,
    },
    colors: [color],
  };
}

function drawIndividualWorkforceCharts() {
  const participationElement = document.getElementById("laborForceChart");
  const employmentElement = document.getElementById("employmentRatioChart");
  const unemploymentElement = document.getElementById("unemploymentRateChart");

  if (!participationElement && !employmentElement && !unemploymentElement) {
    return;
  }

  const rawData = apiData.flourishDemographic.byWorkForce.data.data;
  const years = rawData.slice(1).map((row) => row[0]);

  const participationData = new google.visualization.DataTable();
  participationData.addColumn("string", "Year");
  participationData.addColumn("number", "Participation Rate");
  years.forEach((year, i) => {
    participationData.addRow([year, parseFloat(rawData[i + 1][1])]);
  });

  const employmentData = new google.visualization.DataTable();
  employmentData.addColumn("string", "Year");
  employmentData.addColumn("number", "Employment Ratio");
  years.forEach((year, i) => {
    employmentData.addRow([year, parseFloat(rawData[i + 1][2])]);
  });

  const unemploymentData = new google.visualization.DataTable();
  unemploymentData.addColumn("string", "Year");
  unemploymentData.addColumn("number", "Unemployment Rate");
  years.forEach((year, i) => {
    unemploymentData.addRow([year, parseFloat(rawData[i + 1][3])]);
  });

  if (participationElement) {
    new google.visualization.LineChart(participationElement).draw(
      participationData,
      getChartOptions("Labor Force Participation Rate", "#2e3192"),
    );
  }

  if (employmentElement) {
    new google.visualization.LineChart(employmentElement).draw(
      employmentData,
      getChartOptions("Employment to Population Ratio", "#dc3912"),
    );
  }

  if (unemploymentElement) {
    new google.visualization.LineChart(unemploymentElement).draw(
      unemploymentData,
      getChartOptions("Unemployment Rate", "#ff9900"),
    );
  }
}

//bar chart

function drawScamMethodBarCharts() {
  const wirelessElement = document.getElementById("googleChartWireless");
  const wiredElement = document.getElementById("googleChartWired");
  const voipElement = document.getElementById("googleChartVOIP");

  if (!wirelessElement && !wiredElement && !voipElement) {
    return;
  }

  const rawData = apiData.flourishScamSection.byMethod.data.data;
  const years = rawData.slice(1).map((row) => row[0]);

  const wirelessData = new google.visualization.DataTable();
  wirelessData.addColumn("string", "Year");
  wirelessData.addColumn("number", "Wireless/Mobile");
  years.forEach((year, i) => {
    wirelessData.addRow([year, parseInt(rawData[i + 1][1])]);
  });

  const wiredData = new google.visualization.DataTable();
  wiredData.addColumn("string", "Year");
  wiredData.addColumn("number", "Wired");
  years.forEach((year, i) => {
    wiredData.addRow([year, parseInt(rawData[i + 1][2])]);
  });

  const voipData = new google.visualization.DataTable();
  voipData.addColumn("string", "Year");
  voipData.addColumn("number", "VOIP");
  years.forEach((year, i) => {
    voipData.addRow([year, parseInt(rawData[i + 1][3])]);
  });

  const getBarChartOptions = (title, color) => ({
    title: title,
    legend: { position: "none" },
    colors: [color],
    chartArea: {
      left: 60,
      right: 20,
      top: 40,
      bottom: 60,
      width: "80%",
      height: "70%",
    },
    hAxis: {
      title: "Year",
      slantedText: true,
      showTextEvery: 1,
      textStyle: { fontSize: 10 },
      format: "####",
    },
    vAxis: {
      title: "# of Complaints",
      textStyle: { fontSize: 10 },
      gridlines: { count: 6 },
    },
    titleTextStyle: {
      fontSize: 14,
      bold: true,
    },
  });

  if (wirelessElement) {
    new google.visualization.ColumnChart(wirelessElement).draw(
      wirelessData,
      getBarChartOptions("Wireless/Mobile Complaints", "#2e3192"),
    );
  }

  if (wiredElement) {
    new google.visualization.ColumnChart(wiredElement).draw(
      wiredData,
      getBarChartOptions("Wired Complaints", "#dc3912"),
    );
  }

  if (voipElement) {
    new google.visualization.ColumnChart(voipElement).draw(
      voipData,
      getBarChartOptions("VOIP Complaints", "#ff9900"),
    );
  }
}

function drawScamChartGroup(rawData, groupLabel, metricLabels, colors) {
  const years = rawData.slice(1).map((row) => row[0]);

  metricLabels.forEach((label, index) => {
    const dataTable = new google.visualization.DataTable();
    dataTable.addColumn("string", "Year");
    dataTable.addColumn("number", label);

    years.forEach((year, i) => {
      dataTable.addRow([year, parseInt(rawData[i + 1][index + 1])]);
    });

    const chartOptions = {
      title: `${label} Complaints by ${groupLabel}`,
      legend: { position: "none" },
      colors: [colors[index]],
      chartArea: {
        left: 60,
        right: 20,
        top: 40,
        bottom: 60,
        width: "80%",
        height: "70%",
      },
      hAxis: {
        title: "Year",
        slantedText: true,
        textStyle: { fontSize: 10 },
      },
      vAxis: {
        title: "# of Complaints",
        textStyle: { fontSize: 10 },
        gridlines: { count: 6 },
      },
    };

    const chartId = `googleChart${groupLabel}${label.replace(/[^a-zA-Z]/g, "")}`;
    const chartContainer = document.getElementById(chartId);
    if (chartContainer) {
      new google.visualization.LineChart(chartContainer).draw(
        dataTable,
        chartOptions,
      );
    }
  });
}
